import { render, staticRenderFns } from "./IncidentComponent.vue?vue&type=template&id=7b9e398e&scoped=true"
import script from "./IncidentComponent.vue?vue&type=script&lang=js"
export * from "./IncidentComponent.vue?vue&type=script&lang=js"
import style0 from "./IncidentComponent.vue?vue&type=style&index=0&id=7b9e398e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9e398e",
  null
  
)

export default component.exports